<button mat-icon-button aria-label="Clear" (click)="btnClickedHandler($event)">
    <mat-icon style="color: #464438;">{{ params?.matIconLabel }}</mat-icon>
</button>